﻿import $ from "jquery";

$.widget('customer.getTopBarInfo', {
    options: {
    },

    // Constructor
    _create: function () {
        this._getuser();
    },
    _destroy: function () {
    },
    _getuser: function () {
        var self = this;
        var body = $("body");
        var pageid = self._getMeta('SidID');
        $.ajax({
            url: '/accountinfo/getsession', // NOTE: The path must be lower case because the request is cached in lower case by Varnish
            type: 'GET',
            data: $.param({ pageid: pageid }),
            dataType: 'json',
            success: function (data) {
                if (data.auth) {
                    if (body.data("pagetype") === "StartPage") {
                        var $welcomeHeading = $('#h1id');
                        if ($welcomeHeading.length > 0) {
                            // Append the first name after the welcome text
                            $('#h1id').text(data.lang + ' ' + data.firstname);
                        }
                    }

                    var $ContactForm = $('#page-footer-contact-form');

                    if ($ContactForm.length > 0) {

                        var name = $('#contact-form-name');
                        if (name) {
                            name[0].value = data.name;

                        }
                        var phone = $('#contact-form-phone');
                        if (phone) {
                            phone[0].value = data.telephonenr;
                        }

                        var email = $('#contact-form-email');
                        if (email) {
                            email[0].value = data.mail;
                        }


                    }

                    // Show the element by removeing 'style="display:none"'

                    for (var i = 0; i < self.element[0].querySelectorAll('.topsite-section__links').length; i++) {
                        self.element[0].querySelectorAll('.topsite-section__links')[i].removeAttribute("style");
                        self.element[0].querySelectorAll('.topsite-section__NotLoggedInfo')[i].setAttribute("style", "display: none");
                    }

                    if (data.link !== "") {
                        if (self.element[0].getElementsByClassName('topsite-section__personlink')[0] !== undefined) {
                            for (var i = 0; i < self.element[0].querySelectorAll('.topsite-section__personlink').length; i++) {
                                self.element[0].querySelectorAll('.topsite-section__personlink')[i].setAttribute('href', data.link);
                            }
                        }
                    }

                    if (data.name !== "") {
                        if (self.element[0].getElementsByClassName('topsite-section__personlink')[0] !== undefined) {
                            for (var i = 0; i < self.element[0].querySelectorAll('.topsite-section__personlink span').length; i++) {
                                self.element[0].querySelectorAll('.topsite-section__personlink span')[i].innerText = data.name;
                            }
                        }
                    }

                    if (data.photo !== "") {
                        if (self.element[0].getElementsByClassName('topsite-section__profileimage')[0] !== undefined) {
                            for (var i = 0; i < self.element[0].querySelectorAll('.topsite-section__profileimage').length; i++) {
                                self.element[0].querySelectorAll('.topsite-section__profileimage')[i].setAttribute('src', data.photo);
                                self.element[0].querySelectorAll('.topsite-section__img')[i].setAttribute('href', data.link);
                                self.element[0].querySelectorAll('.topsite-section__profileimage')[i].setAttribute('aria-label', "Länk till din profil i Delve");
                            }
                        }
                    }
                }
            },
            async: true,
            processData: false
        });

    },

    _getMeta: function (metaName) {
        const metas = document.getElementsByTagName('meta');

        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                return metas[i].getAttribute('content');
            }
        }

        return '';
    }

});

